var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from '../utils/clsx';
import { styled } from '../styled';
import { useMergedClasses } from '../styles/classes';
import { Text } from '../text';
import { AuFlagSvg, EuFlagSvg, JpFlagSvg, PiFlagSvg, UsFlagSvg, UkFlagSvg } from './flags';
import { regionComponentName, regionClasses, getRegionUtilityClass } from './region-classes';
var Root = styled('span', { name: regionComponentName, slot: 'Root' })(function (_a) {
    var _b;
    var theme = _a.theme, ownerState = _a.ownerState;
    return _b = {
            display: 'inline-flex',
            alignItems: 'center'
        },
        _b[".".concat(regionClasses.flag)] = __assign({ width: theme.typography.pxToRem(24), height: theme.typography.pxToRem(20) }, (ownerState.size === 'small' && {
            width: theme.typography.pxToRem(20),
            height: theme.typography.pxToRem(16),
        })),
        _b;
});
var Label = styled(Text, { name: regionComponentName, slot: 'Label' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return {
        color: theme.tokens.color_fg_default,
        marginLeft: ownerState.size === 'small' ? theme.spacing(0.5) : theme.spacing(1),
    };
});
function localityIcon(locality) {
    switch (locality) {
        case 'au':
            return AuFlagSvg;
        case 'eu':
            return EuFlagSvg;
        case 'uk':
            return UkFlagSvg;
        case 'tuk':
            return UkFlagSvg;
        case 'jp':
            return JpFlagSvg;
        case 'pi':
            return PiFlagSvg;
        case 'us':
            return UsFlagSvg;
        case 'tus':
            return UsFlagSvg;
        default:
            return UsFlagSvg;
    }
}
function getLabelForLocality(locality) {
    if (!locality) {
        return 'US'; // default if none provided
    }
    if (locality === 'pi') {
        return 'Private Instance';
    }
    return locality.toUpperCase();
}
export var Region = React.forwardRef(function (props, ref) {
    var locality = props.locality, _a = props.size, size = _a === void 0 ? 'medium' : _a, icon = props.icon, labelProp = props.label, _b = props.labelTypographyProps, labelTypographyProps = _b === void 0 ? {} : _b, propClasses = props.classes, className = props.className, rootProps = __rest(props, ["locality", "size", "icon", "label", "labelTypographyProps", "classes", "className"]);
    var classes = useMergedClasses(regionClasses, getRegionUtilityClass, propClasses);
    var flag = icon;
    if (!icon) {
        var LocalityIcon = localityIcon(locality);
        flag = React.createElement(LocalityIcon, { className: classes.flag, "aria-hidden": true });
    }
    var label = labelProp != null ? labelProp : getLabelForLocality(locality);
    return (React.createElement(Root, __assign({ ref: ref, className: clsx(classes.root, className) }, rootProps, { ownerState: { size: size } }, rootProps),
        flag,
        !!label && (React.createElement(Label, __assign({ className: classes.label, ownerState: { size: size }, variant: size === 'small' ? 'caption' : 'body2', color: size === 'small' ? 'textSecondary' : 'textPrimary' }, labelTypographyProps), label))));
});
